import MergeDocumentsModal from './MergeDocumentsModal'
export default MergeDocumentsModal
